import { render, staticRenderFns } from "./ModalAcceptance.vue?vue&type=template&id=66481364"
import script from "./ModalAcceptance.vue?vue&type=script&lang=js"
export * from "./ModalAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports